import React, {Component} from 'react';

import './FilterOptions.css';
import { Button, ToggleButton } from './FormUI';
import { Dropdown } from 'semantic-ui-react';
import { BioDropDown } from './BiopedUI';
import Clinic from '../api/Clinic';
import Icon from './Icon';
import imgArrow from '../images/arrow-left.png';
import AppointmentType from '../api/AppointmentType';
import AccountService from '../api/services/AccountService';
import AppointmentTypeService from '../api/services/AppointmentTypeService';
import {DoctorSettings} from "../api/Doctor";


function saveFilters(filters) {
	let ds = new DoctorSettings();
	console.log('Saving Filters:', filters)
	ds.setData('filters', filters);
}

function getFilters() {
	let ds = new DoctorSettings();
	return ds.getData('filters') || {
		cat: {},
		status: {},
		custom: {}
	};
}

const filterFunctions = {};

filterFunctions.cat = (val) => {
	return (app) => {
		let appType = AppointmentTypeService.GetType(app.appointmentTypeId);
		return appType.appointmentCategoryId == val;
	};
}

filterFunctions.custom = (val) => {
	return (app) => {
		console.log("**++** Filter Test is " + app.appointmentTypeId + "  ==  " + val);
		return app.appointmentTypeId == val;
	};
}

filterFunctions.status = (val) => {
	return (app)=> {
		return app.status.toLowerCase() != val;
	};
}

export default class FilterOptions extends Component{
	constructor(props) {
		super(props);
		this.state = {
			filters: getFilters()
		};
	}

	onListFilterChange = (cat, selected) => {
		let filters = this.state.filters;
		filters[cat] = selected;
		this.handleChange(filters);
	}

	onToggleFilterChange = (cat, val) => {
		let filters = this.state.filters;
		filters.status[cat] = val;
		this.handleChange(filters);
	}

	handleChange = (filters) => {
		saveFilters(filters);
		if(this.props.onChange) {
			this.props.onChange(this.parseFilters(filters));
		}
		this.setState({filters:filters});
	}

	parseFilters(filters) {
		//let filters = this.state.filters;
		let fa = {};

		let cond = {cat:'or', status: 'and', custom: 'or'};

		for(let cat in filters) {
			let category = filters[cat];
			for(let prop in category) {
				if(category[prop]){
					if(fa[cond[cat]] == undefined) {
						fa[cond[cat]] = [];
					}
					fa[cond[cat]].push( filterFunctions[cat](prop) );
				}
			}
		}
		return fa;
	}

	componentDidMount() {
		this.handleChange(getFilters());
	}


	render(){
		return(
			<div className='filter-options table align-middle'>
				<div>
					<div><h4>Filter By:</h4></div>
					<div>
						<AppointmentTypeList type='cat' label='Appointment Type'
							selected={this.state.filters['cat']}
							onChange={
								(selected) => {
									this.onListFilterChange('cat', selected);
								}
							}
						/>
					</div>
					<div>
						<ToggleButton className='filter-toggle' caption='Hide No shows' onIcon='check'
							toggle={this.state.filters.status['no-show']}
							onToggle={(s) => this.onToggleFilterChange('no-show', s)}
						/>
					</div>
					<div>
						<ToggleButton className='filter-toggle' caption='Hide Cancellations' onIcon='check'
							toggle={this.state.filters.status['cancelled']}
							onToggle={(s) => this.onToggleFilterChange('cancelled', s)}
						/>
					</div>
					<div>
						<AppointmentTypeList label='Custom Appointments'
							selected={this.state.filters['custom']}
							onChange={
								(selected) => {
									this.onListFilterChange('custom', selected);
								}
							}
						/>
					</div>
				</div>
			</div>
		)
	}
}

export class AppointmentTypeList extends Component{
	_state = {};
	account = new AccountService();
	//appTypes = (new Clinic(this.account.clinicId)).appTypes.getAll();

	componentDidMount() {
		this.setState(this.props.selected || {})
		//this.state = this.props.selected || {};
	}

	get state(){
		if(this._state[this.account.clinicId] == null){
			this._state[this.account.clinicId] = {};
		}
		return this._state[this.account.clinicId];
	}

	set state(val){
		this._state[this.account.clinicId] = val;
	}

	_renderOptions(){
		//console.log('App Types:', appTypes);
		let options = [];
		let appTypes = (this.props.type === 'cat')? AppointmentTypeService.GetCategoryCache().getAll(): AppointmentTypeService.GetAppTypes();// this.appTypes;
		let propName = (this.props.type === 'cat')? 'appointmentCategoryId':'appointmentTypeId';

		for(let i=0; i < appTypes.length; i++){
			let app = new AppointmentType(appTypes[i]);

			let selected = !!this.state[app[propName]];
			let item =  <div key={app[propName]} className={'list-item table hmax align-middle' + (selected? ' selected': '')} onClick={() => this.handleSelectToggle(app[propName])}>
				<div>
					<div className='align-center'>{(selected? <Icon icon='check' />:'' )}</div>
					<div>{app.name}</div>
				</div>
			</div>;
			options.push(item);
		}

		return options;
	}

	handleSelectToggle = (appId) => {
		console.log("Toggle AppType:", appId)
		let val = !this.state[appId];
		let state = this.state;
		state[appId] = val;
		this.setState(state);
		if(this.props.onChange){
			this.props.onChange(state);
		}

		if(this.props.onToggle){
			this.props.onToggle(appId, val)
		}
		//console.log("Toggle State:", appId)
	}

	isActive(){
		for(let p in this.state){
			if(this.state[p] == true)return true;
		}
		return false;
	}

	render(){
		let label = <div className={'app-type-select' + (this.isActive()? ' active': '')}>{this.props.label || 'Appointment Type'}<img src={imgArrow} className='drop-arrow' /></div>;

		return(
			<BioDropDown label={label} yOffset='0.5em'>
				<div className='filter-drop-down'>
					{this._renderOptions()}
				</div>
			</BioDropDown>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/FilterOptions.js